
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"96","height":"96","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M0 32C0 14.327 14.327 0 32 0h32c17.673 0 32 14.327 32 32v32c0 17.673-14.327 32-32 32H32C14.327 96 0 81.673 0 64V32z","fill":"#FFD1CD"}}),_c('path',{attrs:{"d":"M17.143 32.573c0-8.521 6.907-15.429 15.428-15.429h30.857c8.521 0 15.429 6.908 15.429 15.429V63.43c0 8.52-6.908 15.428-15.429 15.428H32.571c-8.52 0-15.428-6.907-15.428-15.428V32.573z","fill":"#F63220"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M53.85 43.566a1 1 0 10-1.414-1.414L48 46.588l-4.435-4.436a1 1 0 10-1.415 1.414l4.436 4.436-4.436 4.436a1 1 0 001.415 1.414L48 49.416l4.436 4.436a1 1 0 001.414-1.414l-4.436-4.436 4.436-4.436z","fill":"#fff"}})])
          )
        }
      }
    